module.exports = __webpack_public_path__ + "static/img/hatchback-white.21082d6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/hatchback-white.svg
// module id = qmGQ
// module chunks = 82